((app, ng) => {
    app.component("accessToken", {
        templateUrl: "/App/States/Root/Navbar/AccessToken/access.token.html",
        controller: _accessTokenCtrl
    });

    _accessTokenCtrl.$inject = ["$state", "accessTokenService", "dataFeedApi", "$mdDialog"];
    function _accessTokenCtrl($state, accessTokenService, dataFeedApi, $mdDialog) {
        let $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.localToken = accessTokenService.getAccessToken();
        };

        $ctrl.setToken = async (token) => {
            accessTokenService.setAccessToken(token);
            try {
                await dataFeedApi.checkAccess();
                $ctrl.localToken = token;
                accessTokenService.notifyListener();
                return $state.go("Root.Policies.List", { search: null }, { reload: true });
            } catch (err) {
                accessTokenService.removeAccessToken();
                $mdDialog.show({
                    locals: { message: "Incorrect access token. Please try again." },
                    controller: "errorModalCtrl",
                    templateUrl: "/App/States/Modals/Error/error-modal.html",
                    parent: ng.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
                });
            }
        };
    }
})(window.app, window.angular);
